import { render, staticRenderFns } from "./LoadPending.vue?vue&type=template&id=2ffe2b66&scoped=true&"
import script from "./LoadPending.vue?vue&type=script&lang=js&"
export * from "./LoadPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe2b66",
  null
  
)

export default component.exports